<template>
  <div class="login-container">
    <form class="vue-form" @submit.prevent="handleLogin">
      <h2 class="subtitle-form">Bienvenido</h2>
      <h1 class="title-form">Inicia Sesión</h1>
      <div class="description">
        <div>
          <label class="label" for="username">Usuario</label>
          <input type="text" id="username" v-model="username" placeholder="Ingresa tu Nombre de Usuario" required />
        </div>
        <div>
          <label class="label" for="password">Contraseña</label>
          <input type="password" id="password" placeholder="Ingresa tu Contraseña" v-model="password" required />
        </div>
        <div>
          <input type="submit" value="Iniciar" />
        </div>
      </div>
    </form>
    <div class="vue-image-right">
      <img src="../assets/img-login.gif" alt="imagen de referencia" />
    </div>
    <img class="floating-logo" src="../assets/LogoCircle.png" alt="imagen logo fmce" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import Swal from 'sweetalert2';
import bcrypt from 'bcryptjs';
const username = ref('');
const password = ref('');
const authStore = useAuthStore();
const router = useRouter();

const handleLogin = async () => {
  try {
    // Muestra la alerta de cargando
    Swal.fire({
      title: 'Cargando...',
      html: 'Por favor, espere',
      backdrop: false,
      scrollbarPadding: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const salt = await bcrypt.genSalt(10);
    const hashedPassword = await bcrypt.hash(password.value, salt);


    const formData = new FormData();
    formData.append('username', username.value);
    formData.append('password', hashedPassword);

    // Realiza el proceso de login
    await authStore.login(formData, router);

    Swal.close();
  } catch (err) {
    Swal.close();
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Error en el inicio de sesión.',
      backdrop: false,
      scrollbarPadding: false
    });
  }
};

</script>

<style src="../styles/loginPage.css" scoped></style>